import React from "react";
import CommonTitle from "@/components/common/CommonTitle";
import CommonSubtitle from "@/components/common/CommonSubtitle";
import Image, { StaticImageData } from "next/image";

export interface MajorChatSectionProps {
  icon: StaticImageData;
  title: string;
  description: string;
}
export interface MajorChatProps {
  title: string;
  subtitle?: string;
  featureArray: MajorChatSectionProps[];
}

const MajorChat = ({ title, subtitle, featureArray }: MajorChatProps) => {
  return (
    <div className="bg-[#F5F5F5]">
      <div className="container py-8 xl:py-12">
        <div className="mx-auto">
          <div className="mx-auto space-y-4 pb-5 xl:px-20 xl:pb-16">
            <div className="mx-auto text-center sm:max-w-[900px] xl:max-w-[1180px]">
              <CommonTitle
                color="#202020"
                fontWeightClass="font-semibold"
                fontSizeClass="text-[26px] xl:text-[28px]"
              >
                {title}
              </CommonTitle>
            </div>
            <div className="mx-auto text-center sm:max-w-[900px] xl:max-w-[1180px]">
              {subtitle && (
                <CommonSubtitle
                  color="#717171"
                  fontSizeWeight="text-[14px] lg:text-[16px] font-normal"
                >
                  {subtitle}
                </CommonSubtitle>
              )}
            </div>
          </div>
          <div className="mx-auto">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              {featureArray.map((feature, index) => (
                <div
                  key={index}
                  className="relative rounded-[8px] border border-[#D5D5D5]"
                >
                  <div className="h-full overflow-hidden rounded-[8px] bg-white">
                    <div className="flex h-full items-center gap-2 rounded-lg p-4 xl:min-h-[120px] xl:justify-between xl:gap-4">
                      <div className="flex flex-col gap-2">
                        <div className="flex flex-col">
                          <p className="mb-0 flex items-center text-[64px] font-bold leading-none text-[#F2F4F7]">
                            0{index + 1}
                          </p>
                          <h3 className="text-[18px] font-semibold text-[#202020]">
                            {feature.title}
                          </h3>
                        </div>
                        <p className="text-[16px] font-normal text-[#717171] md:max-w-[300px]">
                          {feature.description}
                        </p>
                      </div>
                      <Image
                        src={feature.icon}
                        alt={`${feature.title} - Chat with PDF use case`}
                        width={300}
                        height={300}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MajorChat;
